export default __webpack_public_path__ + "static/media/8.140c5b27.svg";